<core-layout-error-not-found [hidden]="status != STATUS_NOT_FOUND"></core-layout-error-not-found>

<core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading>

<core-version-feedbacks
    *ngIf="approvals != null && approvals.length > 0"
    [feedbacks]="approvals"
    [archiveFeedbackAccess]="archiveFeedbackAccess"
></core-version-feedbacks>
